import React from "react";
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation, Navigate, Outlet } from "react-router-dom";
import Login from "./components/Login/Login";
import FarmerClaim from "./components/farmerComponents/FarmerClaim";
import ClaimsFarmer from "./components/farmerComponents/claims";
import AdminNotif from "./components/adminComponents/AdminNotif";
import AdminHome from "./components/adminComponents/AdminHome";
import AdminResources from "./components/adminComponents/AdminResources";
import LandingPage from "./components/LandingPage";
import Listen from "./components/farmerComponents/Listen";
import FarmerHome from "./components/farmerComponents/FarmerHome";
import Insurance_Provider from "./components/insuranceComponents/insurance_sign.js";
import AdminInsurance from "./components/adminComponents/AdminInsurance";
import SignUp from "./components/Login/SignupFarmer";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Reg from "./components/temp/register";
import Log from "./components/temp/login";
import Profile from "./components/temp/profile";
import View from "./info";
import ViewSupply from "./info_supplychain";
import AdminSupplyChain from "./components/adminComponents/adminsupplychain";
import BuyCoin from "./components/BuyCoin/BuyCoin.js";
// import "./index.css"
import Preloader from "./components/loader/loader";
import ConsumerBuy from "./components/supplychainComponents/consumerbuy";
import AddProductFarmer from "./components/supplychainComponents/AddProductFarmer";
import ViewProductsToBuy from "./components/supplychainComponents/ViewProductsToBuy";
import ViewUserProducts from "./components/supplychainComponents/ViewUserProducts";
import DistributorHome from "./components/supplychainComponents/DistributorHome";
import Checkout from "./components/supplychainComponents/checkout";
function Home() {
	function RequireAuth({ children }) {
		const data = JSON.parse(localStorage.getItem("creds"));
		if (data) {
			return children;
		}
		alert("You must login to view this page");
		return <Navigate to="/login" />;
	}
	function RequireAdmin({ children }) {
		const data = JSON.parse(localStorage.getItem("creds"));
		if (!data) {
			alert("You must login to view this page");
			return <Navigate to="/login" />;
		}
		if (data.type != "A") {
			alert("You must be an admin to view this page");
			return <Navigate to="/" />;
		}
		return children;
	}
	function RequireFarmer({ children }) {
		const data = JSON.parse(localStorage.getItem("creds"));
		if (!data) {
			alert("You must login to view this page");
			return <Navigate to="/login" />;
		}
		if (data.type != "F") {
			alert("You must be a farmer to view this page");
			return <Navigate to="/" />;
		}
		return children;
	}

	function RequireInsurance({ children }) {
		const data = JSON.parse(localStorage.getItem("creds"));
		if (!data) {
			alert("You must login to view this page");
			return <Navigate to="/login" />;
		}
		if (data.type != "I") {
			alert("You must be an insurance provider to view this page");
			return <Navigate to="/" />;
		}
		return children;
	}

	function RequireSupplyChain({ children }) {
		const data = JSON.parse(localStorage.getItem("creds"));
		if (!data) {
			alert("You must login to view this page");
			return <Navigate to="/login" />;
		}
		if (data.type == "F" || data.type == "D" || data.type == "C" || data.type == "R") {
			return children;
		}
		alert("You must be a part of the supply chain to view this page");
		return <Navigate to="/" />;
	}

	function Logout() {
		const data = JSON.parse(localStorage.getItem("creds"));
		if (!data) {
			alert("You must login first to logout");
			return (window.location = "/login");
		}
		localStorage.removeItem("creds");
		return (window.location = "/");
	}

	return (
		<div>
			<Router>
				<Routes>
					<Route path="/" exact element={<LandingPage />} />
					<Route path="/login" element={<Log />} />
					<Route path="/register" element={<Reg />} />
					<Route path="/logout" element={<Logout />} />
					<Route path="/loader" element={<Preloader />} />
					<Route path="/buy" element={<BuyCoin />} />
					{/* <Route path="/consumer" element={<ConsumerBuy />} />
					<Route path="/checkout" element={<Checkout />} /> */}
					<Route path="/notifs" element={<Listen />} />
					<Route
						path="/farmer/addproduct"
						element={
							<RequireFarmer>
								<AddProductFarmer />
							</RequireFarmer>
						}
					/>
					<Route
						path="/buyproduct"
						element={
							<RequireSupplyChain>
								<ViewProductsToBuy />
							</RequireSupplyChain>
						}
					/>
					<Route
						path="/productview"
						element={
							<RequireSupplyChain>
								<ViewUserProducts />
							</RequireSupplyChain>
						}
					/>

					{/* <Route element={<RequireAuth />}> */}
					<Route
						path="/profile"
						element={
							<RequireAuth>
								<Profile />
							</RequireAuth>
						}
					/>
					<Route
						path="/admin/home"
						element={
							<RequireAdmin>
								<AdminHome />
							</RequireAdmin>
						}
					/>
					<Route
						path="/admin/notif"
						element={
							<RequireAdmin>
								<AdminNotif />
							</RequireAdmin>
						}
					/>
					<Route
						path="/admin/insurance"
						element={
							<RequireAdmin>
								<AdminInsurance />
							</RequireAdmin>
						}
					/>
					<Route
						path="/admin/resources"
						element={
							<RequireAdmin>
								<AdminResources />
							</RequireAdmin>
						}
					/>
					<Route
						path="/admin/supplychain"
						element={
							<RequireAdmin>
								<AdminSupplyChain />
							</RequireAdmin>
						}
					/>

					<Route
						path="/farmer/claim"
						element={
							<RequireFarmer>
								<FarmerClaim />
							</RequireFarmer>
						}
					/>
					<Route
						path="/farmer/home"
						element={
							<RequireFarmer>
								<FarmerHome />
							</RequireFarmer>
						}
					/>
					<Route
						path="/farmer/list"
						element={
							<RequireFarmer>
								<ClaimsFarmer />
							</RequireFarmer>
						}
					/>
					<Route
						path="/provider"
						element={
							<RequireInsurance>
								<Insurance_Provider />
							</RequireInsurance>
						}
					/>
					{/* Insurance Provider Routes */}
					<Route element={<RequireInsurance />}>
						<Route path="/provider" element={<Insurance_Provider />} />
					</Route>
					<Route>
						<Route path="/view" element={<View />} />
					</Route>
					<Route>
						<Route path="/viewsupply" element={<ViewSupply />} />
					</Route>
				</Routes>
			</Router>
		</div>
	);
}

export default Home;
